module.exports = __webpack_public_path__ + "static/media/DSV2D.57e552db.jpg";